<template>
  <div class="sm:border-b sm:border-gray-400 sm:pb-5 mb-5">
    <h3 class="text-lg leading-6 font-semibold text-blue-600">
      {{ title || 'Price Options' }}
    </h3>
    <p class="mt-1 max-w-2xl text-sm text-gray-600">
      Create a single price or create tiered pricing whatever suits you.
    </p>
  </div>

  <div class="grid grid-cols-12 gap-6 sm:mb-5">
    <div class="input-group col-span-12 sm:col-span-4">
      <label for="unit_cost"> Unit Cost </label>
      <input
        type="text"
        id="unit_cost"
      />
    </div>
    <div class="input-group col-span-12 sm:col-span-4">
      <label for="price"> Unit Price </label>
      <input
        type="text"
        id="unit_price"
      />
    </div>
    <div class="input-group col-span-12 sm:col-span-4">
      <label for="concentration"> Concentration </label>
      <div class="mt-1 relative rounded-md shadow-sm">
        <input
          type="text"
          id="concentration"
        />
        <div class="absolute inset-y-0 right-0 flex items-center">
          <label
            for="available_uom"
            class="sr-only"
          >
            UoM
          </label>
          <select
            id="available_uom"
            class="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-600 sm:text-sm rounded-md"
          >
            <option>Ea.</option>
            <option>G</option>
            <option>Oz.</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'media-form',
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>
